import { customSchema, validEditorTypes } from "../prosemirror/schemas/custom-schema";
import { customKeymap } from "../prosemirror/keymaps/custom-keymap";
import { EditorState } from "prosemirror-state";
import { EditorView } from "prosemirror-view";
import { DOMSerializer, DOMParser } from "prosemirror-model";
import { history } from "prosemirror-history";
import { tableEditing, columnResizing } from "prosemirror-tables";
import { gapCursor } from "prosemirror-gapcursor";
import { menuPlugin, menuPluginKey } from "../prosemirror/plugins/menu/menu-plugin";
import { notesTrackerPlugin } from "../prosemirror/plugins/notes-tracker/notes-tracker-plugin";
import { customLinkUpdateAttribute } from "../prosemirror/plugins/transactional/custom-link-update-attribute";
import { figureDeletionDetection } from "../prosemirror/plugins/transactional/figure-deletion-detection";
import { uniqueIds } from "../prosemirror/plugins/transactional/unique-ids";
import { notesIdsGeneration } from "../prosemirror/plugins/transactional/notes-ids-generation";
import NoteNodeView from "../prosemirror/nodeviews/note-nodeview";
import GhostNodeView from "../prosemirror/nodeviews/ghost-nodeview";
//import { pasteHandler } from "../prosemirror/plugins/utilities/paste-handler";

export default class RichTextComponent extends HTMLElement {
  #internals;
  static formAssociated = true;

  constructor() {
    super();
    this.#internals = this.attachInternals();
  }
  
  connectedCallback() {
    let editorType = this.getAttribute("type");
    if(editorType === null || !validEditorTypes.includes(editorType)) {
      editorType = "basic";
    }
    const editorState = EditorState.create({
      schema: customSchema,
      doc: DOMParser.fromSchema(customSchema).parse(this.querySelector("[data-element='editor-area']")),
      plugins: [
        customKeymap,
        history(),
        menuPlugin(editorType),
        gapCursor(),
        customLinkUpdateAttribute,
        figureDeletionDetection,
        uniqueIds,
        notesIdsGeneration,
        notesTrackerPlugin,
        tableEditing()
        //pasteHandler(customSchema)
      ]
    });
    this.input = this.querySelector("input");
    this.removeAttribute("id");
    this.view = new EditorView({ mount: this.querySelector("[data-element='editor-area']") }, {
      state: editorState,
      nodeViews: {
        ghost: (node, view, getPos) => { return new GhostNodeView(node, view, getPos); },
        note: (node, view, getPos) => { return new NoteNodeView(node, view, getPos); }
      },
      dispatchTransaction: (tr) => {
        const newState = this.view.state.apply(tr);
        this.view.updateState(newState);

        const serializer = DOMSerializer.fromSchema(customSchema),
          fragment = serializer.serializeFragment(newState.doc.content),
          container = document.createElement("div");

        container.appendChild(fragment);

        const { innerHTML } = container,
          { content } = this.view.state.doc,
          isEmpty = content.size === 2 && content.content[0].content.size === 0;

        this.#internals.setFormValue(isEmpty ? "" : innerHTML);
        this.input.value = isEmpty ? "" : innerHTML;
      },
      handleDOMEvents: {
        focus: () => {
          this.setToMainView();
        }
      }
    });

    this.setToMainView();
  }

  setToMainView() {
    const { tr } = this.view.state;
      tr.setMeta(menuPluginKey, {
        action: "viewChange",
        view: this.view
      });

    this.view.dispatch(tr);
  }
}
